import { /*Map,*/ fromJS } from "immutable";
import { handleActions, createAction } from "redux-actions";

const FORCE_APP_UPDATE_HOUR = 24;
const FORCE_APP_UPDATE_SECS = FORCE_APP_UPDATE_HOUR * 60 * 60;
const CHECKER_FN_PERIOD_SEC = 60;

const SET_APP_EXP_TIME = "appUpdate/SET_APP_EXP_TIME";
const SET_INTERVAL_ID = "appUpdate/SET_INTERVAL_ID";
const SET_NEED_UPDATE_APP = "appUpdate/SET_NEED_UPDATE_APP";

const setAppExpTime = createAction(SET_APP_EXP_TIME);
const setIntervalId = createAction(SET_INTERVAL_ID);
const setNeedUpdateApp = createAction(SET_NEED_UPDATE_APP);

const getAppUpdateState = ({ getState }) => {
  const appUpdateState = getState().appUpdate.toJS();
  return appUpdateState;
};

const terminateLoopFn = ({ getState }) => {
  const { intervalId } = getAppUpdateState({ getState });
  if (intervalId) clearInterval(intervalId);
};

const getCheckCallbackFunction =
  ({ dispatch, getState }) =>
  async () => {
    const { appExpTime } = getAppUpdateState({ getState });
    const nowTime = new Date();
    const isTimeExpired = nowTime > appExpTime;
    const hasNewVersionReleased =
      "serviceWorker" in navigator &&
      "maunentOne" in window &&
      !!window.maunentOne.newVersionFromSW;
    if (isTimeExpired || hasNewVersionReleased) {
      terminateLoopFn({ getState });
      dispatch(setNeedUpdateApp(true));
    }
  };

const initCheckLoopFn = ({ dispatch, getState }) => {
  terminateLoopFn({ getState });
  const intervalId = setInterval(
    getCheckCallbackFunction({ dispatch, getState }),
    CHECKER_FN_PERIOD_SEC * 1000
  );
  dispatch(setIntervalId(intervalId));
};

export const recordStartTime = () => (dispatch, getState) => {
  const appUpdateState = getAppUpdateState({ getState });
  const { appExpTime } = appUpdateState;
  if (appExpTime) return null;

  const newAppExpTime = new Date();
  newAppExpTime.setSeconds(newAppExpTime.getSeconds() + FORCE_APP_UPDATE_SECS);
  dispatch(setAppExpTime(newAppExpTime));

  initCheckLoopFn({ dispatch, getState });
};

const initialState = fromJS({
  appExpTime: null,
  intervalId: null,
  needUpdateApp: false
});

export default handleActions(
  {
    [SET_APP_EXP_TIME]: (state, action) => {
      const appExpTime = action.payload;
      return state.set("appExpTime", fromJS(appExpTime));
    },
    [SET_INTERVAL_ID]: (state, action) => {
      const intervalId = action.payload;
      return state.set("intervalId", fromJS(intervalId));
    },
    [SET_NEED_UPDATE_APP]: (state, action) => {
      const needUpdateApp = action.payload;
      return state.set("needUpdateApp", fromJS(needUpdateApp));
    }
  },
  initialState
);
